.card {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding: var(--pgm-sys-spacing-4);
}

.name {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card .nameTooltip {
  display: block;
  max-width: 100%;
  min-width: 0;
}

.row {
  align-items: flex-start;
  display: flex;
  gap: var(--pgm-sys-spacing-2);
}

.icon {
  color: var(--pgm-sys-color-on-surface-variant);
  flex-shrink: 0;
  font-size: 24px;
  font-variation-settings:
    "FILL" 1,
    "wght" 600,
    "GRAD" 0,
    "opsz" 24;
  line-height: 24px;
}

.rowContent {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.card .link {
  overflow-wrap: anywhere;
}

.card .link:hover,
.card .link:focus {
  color: color-mix(
    in srgb,
    var(--pgm-sys-color-on-surface) 52%,
    var(--pgm-sys-color-secondary)
  );
  text-decoration: underline;
}

.separator {
  color: var(--pgm-sys-color-on-surface);
}

.phone {
  color: var(--pgm-sys-color-on-surface);
}

.empty {
  color: var(--pgm-sys-color-on-surface);
  opacity: 0.32;
}

.tag {
  background-color: var(--pgm-sys-color-surface-container-highest);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-surface);
  padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-2);
  white-space: nowrap;
}

.srOnly {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
